import React, { useState } from 'react';
import AllocationTemplates, { ALLOCATION_TEMPLATES } from './AllocationTemplates';

function AllocationPreview() {
  const [selectedTemplate, setSelectedTemplate] = useState('current');
  const [customAllocation, setCustomAllocation] = useState({
    taxes: 20,
    business: 20,
    personal: 55,
    savings: 5
  });

  const handleSelectTemplate = (templateKey) => {
    setSelectedTemplate(templateKey);
    if (templateKey !== 'custom') {
      setCustomAllocation(ALLOCATION_TEMPLATES[templateKey].allocation);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-700 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-6">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Allocation Templates Preview</h1>
          <p className="text-gray-600 dark:text-gray-300 dark:text-gray-300">This is how the customizable allocation feature will look!</p>
        </div>

        <AllocationTemplates
          selectedTemplate={selectedTemplate}
          onSelectTemplate={handleSelectTemplate}
          customAllocation={customAllocation}
          onCustomChange={setCustomAllocation}
        />

        {/* Preview of Selected Allocation */}
        <div className="mt-6 bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Current Selection Preview</h2>
          <div className="grid grid-cols-4 gap-4">
            <div className="p-4 bg-red-50 dark:bg-red-900/20 rounded-lg">
              <p className="text-sm text-gray-600 dark:text-gray-300 dark:text-gray-300">Taxes</p>
              <p className="text-2xl font-bold text-red-600">{customAllocation.taxes}%</p>
            </div>
            <div className="p-4 bg-purple-50 rounded-lg">
              <p className="text-sm text-gray-600 dark:text-gray-300 dark:text-gray-300">Business</p>
              <p className="text-2xl font-bold text-purple-600">{customAllocation.business}%</p>
            </div>
            <div className="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg">
              <p className="text-sm text-gray-600 dark:text-gray-300 dark:text-gray-300">Personal</p>
              <p className="text-2xl font-bold text-green-600">{customAllocation.personal}%</p>
            </div>
            <div className="p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
              <p className="text-sm text-gray-600 dark:text-gray-300 dark:text-gray-300">Savings</p>
              <p className="text-2xl font-bold text-yellow-600">{customAllocation.savings}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllocationPreview;
